<template>
  <a @click="toContact">
    <div class="toggle-button" :class="{active : toggled}">
        <div class="text-wrapper">
          <div class="text">Contact</div>
        </div>
        <v-btn fab x-small v-ripple="false" id="no-background-hover">
          <v-icon v-if="toggled" class="exit" :class="{active : toggled}" color="black" dark>mdi-close</v-icon>
        </v-btn>
    </div>
  </a>
</template>

<script>
export default {
  computed: {
    toggled () { return this.$store.state.contactToggle }
  },
  methods: {
    toContact () {
      if (this.toggled) {
        this.$router.go(-1)
      } else {
        this.$store.dispatch('setContactToggle', true)
        this.$router.push('contact')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .toggle-button{
    display: flex;
    align-items: center;
    margin: 0px 0px 0px 40px;
    font-size: 16px;
    background-color: #414141;
    border-radius: 30px;
    cursor: pointer;
    .text-wrapper{
      // display: flex;
      // place-items: center;
      overflow: hidden;
      max-width: 150px;
      transition: max-width 0.5s ease-in-out;
      .text{
        padding: 0 10px 0 10px;
        transition: font-size 0.5s ease-in-out;
      }
    }
    .exit{
      transition: opacity 0.5s ease-in-out;
    }
    &.active{
      .text-wrapper{
        max-width: 0px;

        .text{
          font-size: 0px;
        }
      }
    }
    #no-background-hover::before {
      background-color: transparent !important;

      &.active{
        .exit{
          opacity: 1;
        }

      }
    }
  }
</style>
